<template>
  <div class="container">
    <!-- 表格显示 -->
    <el-table
        v-loading="listLoading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%">
      <el-table-column label="ISBN" align="center">
        <template v-slot="{ row }">
          <span>{{ row.StrISBN }}</span>
        </template>
      </el-table-column>
      <el-table-column label="提交人" align="center">
        <template v-slot="{ row }">
          <span>{{ row.StrCreatorName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="提交时间" align="center">
        <template v-slot="{ row }">
          <span>{{ row.created_at.substring(0, 10) }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
          fixed="right"
          width="390px"
      >
        <template v-slot="{ row }">
          <el-button type="primary" size="mini" @click="BookErrorCorrection(row)">纠错</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 图书纠错弹窗（与 IsbnBookInfo 共用） -->
    <book-error-correction-dialog
        v-model:visible="dialogVisible"
        :isbn="currentIsbn"
        @success="getList"
    />
    <!-- 分页 -->
    <div style="margin-top: 50px; text-align: right">
      <el-pagination
          background
          :total="total"
          :current-page="listQuery.Page"
          :page-size="listQuery.PerPage"
          :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
          layout="prev,pager,next,jumper,sizes,total"
          @size-change="pageSizeChange"
          @current-change="currPageChange"
      />
    </div>
  </div>
</template>

<script>
import {BASE_URL} from "@/utils/constants";
import BookErrorCorrectionDialog from "@/components/BookErrorCorrectionDialog.vue";

export default {
  name: "errorManager",
  components: {BookErrorCorrectionDialog},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        Page: 1,
        PerPage: 10,
      },
      dialogVisible: false,
      currentIsbn: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$axios({
        url: BASE_URL + "system/errorIsbnInfos",
        method: "post",
        data: JSON.stringify(this.listQuery),
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          this.list = res.data.msg;
          this.total = res.data.total;
          this.listLoading = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
          this.listLoading = false;
        }
      });
    },
    // 打开纠错弹窗
    BookErrorCorrection(row) {
      this.currentIsbn = row.StrISBN;
      this.dialogVisible = true;
    },
    pageSizeChange(Perpage) {
      this.listQuery.PerPage = Perpage;
      this.getList();
    },
    currPageChange(Page) {
      this.listQuery.Page = Page;
      this.getList();
    },
  }
}
</script>

<style scoped>
</style>
